module.exports = __webpack_public_path__ + "img/Deco_fete.c6b4ab3.jpg";